// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import { css } from "styled-components";

styles.startQtyTextField = {
    cssOverrides: {
        formField: css`
            max-width: 60px;
            margin-right: 5px;
            input {
                text-align: center;
            }
            &&&&&& input:disabled {
                color: black;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
    },
};

styles.endQtyTextField = {
    cssOverrides: {
        formField: css`
            max-width: 60px;
            margin-left: 5px;
            input {
                text-align: center;
            }
            &&&&&& input:disabled {
                color: black;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
    },
};

styles.removePriceBreakIcon = {
    src: "Delete",
    color: "tertiary",
    size: 18,
};
